import fetch from './fetch'

export default {
  submitForgotPassword (data) {
    let request = fetch({
      url: `/auth/recover`,
      method: 'post',
      data
    })
    return request.call()
  },
  resetPassword (payload) {
    if (!payload.password || !payload.passwordResetToken) {
      // TO DO - Return error, raise notification
      return false
    }

    payload = _.pick(payload, [ 'password', 'passwordResetToken' ])

    let request = fetch({
      url: `/auth/reset-password`,
      method: 'post',
      data: payload
    })

    return request.call()
  },
  sendWelcomeEmail (data) {
    let request = fetch({
      url: `/auth/send-welcome-email`,
      method: 'post',
      data: data
    })
    return request.call()
  },
  bulkSendWelcomeEmail (data) {
    const request = fetch({
      url: `/auth/bulk-send-welcome-email`,
      method: 'post',
      data
    })
    return request.call()
  },
  userAcceptedTos (payload) {
    const userId = payload.id

    let request = fetch({
      url: `/user/` + userId + `/accepted-tos/`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  userAcceptedEUA (payload) {
    const userId = payload.id
    console.log(payload)

    let request = fetch({
      url: `/user/` + userId + `/accepted-eua`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  sendPasswordResetEmail (payload) {
    // const email = payload.email
    let request = fetch({
      url: `/auth/send-reset-password-email`,
      method: 'post',
      data: payload
    })

    return request.call()
  },
  getUser (payload) {
    const request = fetch({
      url: '/user',
      method: 'get',
      data: {},
      payload
    })

    return request.call()
  },
  getUsers (payload) {
    let request = fetch({
      url: `/user/`,
      method: 'get',
      data: {},
      payload
    })

    return request.call()
  },
  createUser (payload) {
    let request = fetch({
      url: `/user/`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  bulkCreateUsers (payload) {
    const request = fetch({
      url: '/user/create',
      method: 'post',
      data: payload
    })
    return request.call()
  },
  updateUser (payload) {
    const { id, data } = payload
    let request = fetch({
      url: `/user/` + id,
      method: 'patch',
      data: data
    })
    return request.call()
  },
  getUserRecordCount (payload) {
    let request = fetch({
      url: `/model/user/count`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getUserMember (payload) {
    let request = fetch({
      url: `/usermember/`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  createUserMember (payload) {
    let request = fetch({
      url: `/usermember/`,
      method: 'post',
      data: {},
      payload
    })
    return request.call()
  },
  updateUserMember (payload) {
    const userMemberId = payload.id

    let request = fetch({
      url: `/usermember/` + userMemberId,
      method: 'post',
      data: {},
      payload
    })
    return request.call()
  },
  deleteUserMember (payload) {
    const userMemberId = payload.id

    let request = fetch({
      url: `/usermember/` + userMemberId,
      method: 'delete',
      data: {},
      payload
    })
    return request.call()
  },
  getUserForLists (payload) {
    let request = fetch({
      url: `/user/list`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getUserDashboard (payload) {
    let request = fetch({
      url: `/user/dashboard`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  deactivateUsers (payload) {
    const request = fetch({
      url: '/user/deactivate',
      method: 'post',
      data: payload
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js